import {
  FETCH_PARTNERS,
  FETCH_PARTNERS_FOR_SELECT,
  UPDATE_OPERATIONS_B2C,
  UPDATE_OPERATIONS_B2B,
  UPDATE_EXPIRATIONS,
  UPDATE_OPERATION_SELECT,
  SET_PARTNERS_PROPERTY,
  FETCH_PARTNERS_THEMES,
  FETCH_PARTNER_BY_ID
} from 'store/actions/partner';
import { setValueObjectByField } from 'helpers/object';
import { dateToString } from 'helpers/date';
import { STATUS_VARIATIONS } from 'store/enums';
import { i18n } from '@/setup/i18n';

export default {
  [SET_PARTNERS_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [FETCH_PARTNERS]: (state, partners) => {
    state.partners = [
      ...partners,
      {
        id: 0,
        partnerName: 'default'
      }
    ];
  },

  [FETCH_PARTNERS_FOR_SELECT]: (state, partners) => {
    state.partnersForSelect = partners
      .sort((a, b) => {
        if (a.partnerName > b.partnerName) return 1;
        if (a.partnerName < b.partnerName) return -1;
        return 0;
      })
      .map(item => ({
        value: item.partnerId,
        label: `${item.partnerName} - ${item.partnerId}`,
        logoUrl: item.partnerLogoURL,
        maxTopCampaigns: item.maxTopCampaigns,
        flows: item.flows
      }));
  },

  [FETCH_PARTNERS_THEMES]: state => {
    state.partnersThemes = [
      'default',
      'ald-orange',
      'ald-bbva',
      'ald-amovens',
      'ald-privaterenting',
      'ald-selfbank',
      'ald-opelrenting',
      i18n.t('ui.select.labelNew')
    ];
  },

  [UPDATE_OPERATIONS_B2C]: (state, operations) => {
    state.operations = operations.map(item => {
      const objFormat = item;
      const { fullName, documentId, mobile, email } = item;
      objFormat.createDate = dateToString(item.createDate);
      objFormat.updateDateHours = dateToString(item.updateDate, 'DD/MM/YYYY HH:mm');
      objFormat.updateDate = dateToString(item.updateDate);
      objFormat.signUpdateDate = dateToString(item.signUpdateDate);
      objFormat.riskUpdateDate = dateToString(item.riskUpdateDate);
      objFormat.identification = {
        fullName,
        documentId,
        mobile,
        email
      };
      objFormat.plateNumber = {
        plateNumber: item.plateNumber
      };
      objFormat.campaignType = {
        campaignType: item.campaignType
      };
      objFormat.process = {
        createDate: objFormat.createDate,
        custodyDate: item.custodyDate ? dateToString(item.custodyDate) : '-',
        availableDate: item.availableDate ? dateToString(item.availableDate) : '-',
        pickupDate: item.pickupDate ? dateToString(item.pickupDate) : '-'
      };
      objFormat.vehicleOrderId = item.vehicleOrderId;
      objFormat.vehicle = {
        vehicle: item.vehicle,
        termInMonths: item.termInMonths,
        yearKms: item.yearKms
      };
      objFormat.offerCamp = item.quoteId;
      objFormat.offerClient = item.quoteIdCustomer;
      objFormat.operationStatusFormatter = {
        status: item.operationStatus.replace('_', ' '),
        variant: STATUS_VARIATIONS.OPERATION_STATUS[item.operationStatus.replace(' ', '_')]
      };
      objFormat.globalStatus = {
        status: item.globalStatus.replace(/_/g, ' '),
        variant:
          STATUS_VARIATIONS.RISK_STATUS[
            item.operationStatus === 'CANCELADA' || item.operationStatus === 'NO_INTERESADO'
              ? item.operationStatus
              : item.globalStatus
          ]
      };
      objFormat.riskStatus = {
        status: item.riskStatus.replace(/_/g, ' '),
        variant: STATUS_VARIATIONS.RISK_STATUS[item.riskStatus]
      };
      objFormat.signStatusFormatter = {
        icon: item.signStatus === 'CONTRATO_FIRMADO' ? 'check' : 'pencil',
        status: item.signStatus.replace('_', ' '),
        color: STATUS_VARIATIONS.SIGN_STATUS[item.signStatus]
      };
      return objFormat;
    });
  },

  [UPDATE_OPERATIONS_B2B]: (state, operations) => {
    state.operationsB2B = operations.map(item => {
      const objFormat = item;
      const { fullName, documentId, mobile, email } = item;
      objFormat.createDate = dateToString(item.createDate);
      objFormat.updateDateHours = dateToString(item.updateDate, 'DD/MM/YYYY HH:mm');
      objFormat.updateDate = dateToString(item.updateDate);
      objFormat.signUpdateDate = dateToString(item.signUpdateDate);
      objFormat.riskUpdateDate = dateToString(item.riskUpdateDate);
      objFormat.identification = {
        fullName,
        documentId,
        mobile,
        email
      };
      objFormat.plateNumber = {
        plateNumber: item.plateNumber
      };
      objFormat.campaignType = {
        campaignType: item.campaignType
      };
      objFormat.process = {
        createDate: objFormat.createDate,
        custodyDate: item.custodyDate ? dateToString(item.custodyDate) : '-',
        availableDate: item.availableDate ? dateToString(item.availableDate) : '-',
        pickupDate: item.pickupDate ? dateToString(item.pickupDate) : '-'
      };
      objFormat.vehicleOrderId = item.vehicleOrderId;
      objFormat.vehicle = {
        vehicle: item.vehicle,
        termInMonths: item.termInMonths,
        yearKms: item.yearKms
      };
      objFormat.offerCamp = item.quoteId;
      objFormat.offerClient = item.quoteIdCustomer;
      objFormat.operationStatusFormatter = {
        status: item.operationStatus.replace('_', ' '),
        variant: STATUS_VARIATIONS.OPERATION_STATUS[item.operationStatus.replace(' ', '_')]
      };
      objFormat.globalStatus = {
        status: item.globalStatus.replace(/_/g, ' '),
        variant:
          STATUS_VARIATIONS.RISK_STATUS[
            item.operationStatus === 'CANCELADA' || item.operationStatus === 'NO_INTERESADO'
              ? item.operationStatus
              : item.globalStatus
          ]
      };
      objFormat.riskStatus = {
        status: item.riskStatus.replace(/_/g, ' '),
        variant: STATUS_VARIATIONS.RISK_STATUS[item.riskStatus]
      };
      objFormat.signStatusFormatter = {
        icon: item.signStatus === 'CONTRATO_FIRMADO' ? 'check' : 'pencil',
        status: item.signStatus.replace('_', ' '),
        color: STATUS_VARIATIONS.SIGN_STATUS[item.signStatus]
      };
      return objFormat;
    });
  },

  [UPDATE_EXPIRATIONS]: (state, operations) => {
    state.expirations = operations.map(item => {
      const objFormat = item;
      const { fullName, documentId, mobile } = item;
      objFormat.expirationDate = dateToString(item.expirationDate);
      objFormat.identification = {
        fullName,
        documentId,
        mobile
      };
      return objFormat;
    });
  },

  [UPDATE_OPERATION_SELECT]: (state, operation) => {
    state.selectedOperation = operation;
  },

  [FETCH_PARTNER_BY_ID]: (state, partners) => {
    if (partners.length > 0) {
      state.partnerInfo = partners[0];
    } else {
      state.partnerInfo = null;
    }
  }
};
